/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespCollectionsComponents_collectionsModules$ref = any;
type SbRespCollectionsComponents_itemSearch$ref = any;
type SbRespCreatorSpotlightModule_collectionsModules$ref = any;
type SbSharedCollectionsModulesHeroModule_collectionsModules$ref = any;
type SharedProductCarousel_collectionsModules$ref = any;
export type SbRespCollectionsModules_itemSearch$ref = any;
export type SbRespCollectionsModules_itemSearch = {
    readonly collectionsModules: ReadonlyArray<{
        readonly moduleType: string | null;
        readonly id: string | null;
        readonly " $fragmentRefs": SbSharedCollectionsModulesHeroModule_collectionsModules$ref & SharedProductCarousel_collectionsModules$ref & SbRespCollectionsComponents_collectionsModules$ref & SbRespCreatorSpotlightModule_collectionsModules$ref;
    } | null> | null;
    readonly " $fragmentRefs": SbRespCollectionsComponents_itemSearch$ref;
    readonly " $refType": SbRespCollectionsModules_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespCollectionsModules_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "contentModuleId",
            "type": "String"
        }
    ],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "collectionsModules",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "previewId",
                    "variableName": "contentModuleId"
                }
            ],
            "concreteType": null,
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "moduleType",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "id",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "FragmentSpread",
                    "name": "SbSharedCollectionsModulesHeroModule_collectionsModules",
                    "args": null
                },
                {
                    "kind": "FragmentSpread",
                    "name": "SharedProductCarousel_collectionsModules",
                    "args": null
                },
                {
                    "kind": "FragmentSpread",
                    "name": "SbRespCollectionsComponents_collectionsModules",
                    "args": null
                },
                {
                    "kind": "FragmentSpread",
                    "name": "SbRespCreatorSpotlightModule_collectionsModules",
                    "args": null
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "SbRespCollectionsComponents_itemSearch",
            "args": null
        }
    ]
} as any);
(node as any).hash = '15c83ab53da2f2504b701d2d225412ce';
export default node;
